import axiosInstance from './axiosInstance';

const getSlides = () =>
  axiosInstance.get('/internal/config/carousels?section=kriptoservices::home');

export default getSlides;
